/** Arabic for the provider workspace's orders, menu & stock, and related screens. */
export const providerOpsAr: Record<string, string> = {
  // Orders board
  "Pick a venue to see its orders.": "اختار مكان عشان تشوف طلباته.",
  "Food & drink orders": "طلبات الأكل والمشروبات",
  "All caught up. New orders from staff and from the app appear here.": "مفيش طلبات مستنية. الطلبات الجديدة من الموظفين أو من التطبيق هتظهر هنا.",
  "{count} open orders. Work oldest first.": "{count} طلبات مفتوحة. ابدأ بالأقدم.",
  "Menu & stock": "المنيو والمخزون",
  "New order": "طلب جديد",
  "Table": "طاولة",
  "From the app": "من التطبيق",
  "Move back to {status}": "رجّعه لـ {status}",
  "Earlier today": "في وقت سابق النهارده",
  "{count} served or cancelled in the last 6 hours": "{count} اتقدّم أو اتلغى في آخر 6 ساعات",
  "Nothing yet.": "لسه مفيش.",
  "Pick the table, tap what they want, then send it to the queue.": "اختار الطاولة، دوس على اللي عايزينه، وبعدين ابعته للطابور.",
  "Order sent for {unit}.": "الطلب اتبعت لـ {unit}.",
  "Cancel this order?": "تلغي الطلب ده؟",
  "{unit}: {items}. It comes off the bill and any stock it used goes back.": "{unit}: {items}. هيتشال من الحساب وأي مخزون اتسحب هيرجع.",
  "Other reason": "سبب تاني",
  "Or type a reason": "أو اكتب السبب",
  "Keep order": "سيب الطلب",
  "Cancel order": "إلغاء الطلب",
  "New": "جديد",
  "No new orders.": "مفيش طلبات جديدة.",
  "Nothing being prepared.": "مفيش حاجة بتتحضّر.",
  "Ready to serve": "جاهز للتقديم",
  "Nothing waiting to be served.": "مفيش حاجة مستنية تتقدّم.",
  "Preparing": "بيتحضّر",
  "Served": "اتقدّم",
  "Cancelled": "ملغي",
  "Start preparing": "ابدأ التحضير",
  "Mark ready": "جاهز",
  "Mark served": "اتقدّم",
  "just now": "دلوقتي",
  "{count} min": "{count} دقيقة",
  "{hours} h {minutes} min": "{hours} س {minutes} د",
  "Could not load orders. Check your connection.": "مقدرناش نحمّل الطلبات. اتأكد من الاتصال.",
  "Could not update the order. Check your connection and try again.": "مقدرناش نحدّث الطلب. اتأكد من الاتصال وجرّب تاني.",
  "Out of stock": "خلص من المخزون",
  "Guest changed their mind": "الضيف غيّر رأيه",
  "Entered by mistake": "اتسجّل بالغلط",
  "Guest left": "الضيف مشي",

  // Order builder
  "Choose who the order is for.": "اختار الطلب لمين.",
  "Add at least one item.": "ضيف صنف واحد على الأقل.",
  "Could not send the order. Check your connection and try again.": "مقدرناش نبعت الطلب. اتأكد من الاتصال وجرّب تاني.",
  "No one is playing right now.": "مفيش حد بيلعب دلوقتي.",
  "Orders are added to a table's bill, so start a session on the Floor first.": "الطلبات بتتضاف على حساب الطاولة، فابدأ جلسة من الصالة الأول.",
  "Order for": "الطلب لـ",
  "Search the menu": "دوّر في المنيو",
  "Nothing on the menu yet.": "لسه مفيش حاجة في المنيو.",
  "Set up the menu": "جهّز المنيو",
  "{count} in order": "{count} في الطلب",
  "This order": "الطلب ده",
  "Tap items on the menu to add them.": "دوس على الأصناف في المنيو عشان تضيفها.",
  "Remove {name}": "شيل {name}",
  "One less {name}": "واحد أقل من {name}",
  "One more {name}": "واحد كمان من {name}",
  "Note for the kitchen (optional)": "ملاحظة للمطبخ (اختياري)",
  "No ice, extra spicy…": "من غير تلج، حار زيادة…",
  "Added to the table's bill at checkout.": "هيتضاف على حساب الطاولة وقت الدفع.",
  "Sending…": "بيتبعت…",
  "Send order ({count})": "ابعت الطلب ({count})",
  "Send order": "ابعت الطلب",
  "Add an order": "ضيف طلب",
  "Order sent to the queue.": "الطلب اتبعت للطابور.",
  "Total": "الإجمالي",
  "All": "الكل",
  "Category": "التصنيف",
  "Loading menu…": "بنحمّل المنيو…",
  "Loading…": "بنحمّل…",

  // Menu & stock
  "Could not load the menu.": "مقدرناش نحمّل المنيو.",
  "Sold out": "خلص",
  "{count} left": "فاضل {count}",
  "Saved offline. It will sync when you're back online.": "اتحفظ من غير نت. هيتزامن لما النت يرجع.",
  "Items that were ever ordered can't be deleted; take them off the menu instead.": "الأصناف اللي اتطلبت قبل كده مينفعش تتمسح؛ شيلها من المنيو بدل كده.",
  "{name} deleted.": "{name} اتمسح.",
  "Pick a venue to manage its menu.": "اختار مكان عشان تدير المنيو بتاعه.",
  "What guests can order, and how many you have left. Stock goes down with every order and back up if an order is cancelled.": "اللي الضيوف يقدروا يطلبوه، وفاضل منه كام. المخزون بيقل مع كل طلب ويرجع لو الطلب اتلغى.",
  "Stock history": "سجل المخزون",
  "Offline: showing the last saved menu. Stock numbers may be out of date.": "مفيش نت: بنعرض آخر منيو محفوظ. أرقام المخزون ممكن تكون قديمة.",
  "All items ({count})": "كل الأصناف ({count})",
  "Needs restock ({count})": "محتاج تزويد ({count})",
  "Off the menu ({count})": "برا المنيو ({count})",
  "Search items": "دوّر على صنف",
  "No menu items yet.": "لسه مفيش أصناف في المنيو.",
  "Add the food and drinks you sell. Turn on stock tracking for anything you want to count, like cans and snacks.": "ضيف الأكل والمشروبات اللي بتبيعها. شغّل عدّ المخزون لأي حاجة عايز تعدّها، زي الكانز والسناكس.",
  "No items match.": "مفيش أصناف مطابقة.",
  "Running low": "قرب يخلص",
  "in stock": "في المخزون",
  "Stock not counted": "مش بيتعدّ",
  "Guests can order it": "الضيوف يقدروا يطلبوه",
  "On the menu": "في المنيو",
  "Hidden": "مخفي",
  "Stock changes need a connection.": "تعديل المخزون محتاج نت.",
  "Update stock": "حدّث المخزون",
  "Track stock": "عدّ المخزون",
  "Edit {name}": "تعديل {name}",
  "Only the owner can add items or change prices. You can update stock.": "المالك بس يقدر يضيف أصناف أو يغيّر الأسعار. إنت تقدر تحدّث المخزون.",
  "Only the owner can change the menu. Updating stock needs a manager's approval.": "المالك بس يقدر يغيّر المنيو. تحديث المخزون محتاج موافقة مدير.",
  "{name} saved.": "{name} اتحفظ.",
  "{count} item sold out": "صنف واحد خلص",
  "{count} items sold out": "{count} أصناف خلصت",
  "{count} item running low": "صنف واحد قرب يخلص",
  "{count} items running low": "{count} أصناف قربت تخلص",
  "Show": "اعرض",
  "Hide": "اخفي",
  "Dismiss": "إخفاء",
  "Retry": "إعادة المحاولة",
  "Add item": "ضيف صنف",
  "Delete item": "امسح الصنف",
  "Could not update item.": "مقدرناش نحدّث الصنف.",
  "Could not delete item.": "مقدرناش نمسح الصنف.",

  // Stock dialog
  "Enter how many are on the shelf.": "اكتب العدد اللي على الرف.",
  "Enter a number above 0.": "اكتب رقم أكبر من 0.",
  "{name}: {count} in stock.": "{name}: {count} في المخزون.",
  "Could not update stock. Check your connection and try again.": "مقدرناش نحدّث المخزون. اتأكد من الاتصال وجرّب تاني.",
  "Add delivery": "استلام بضاعة",
  "You received more. Enter how many arrived.": "استلمت كمية جديدة. اكتب وصل كام.",
  "Set count": "جرد",
  "You counted the shelf. Enter the exact number you have.": "عدّيت الرف. اكتب العدد بالظبط.",
  "Remove": "شيل",
  "Spoiled, broken or used by staff. Enter how many to take off.": "بايظ أو مكسور أو استخدمه الموظفين. اكتب هتشيل كام.",
  "Update stock: {name}": "تحديث المخزون: {name}",
  "Start counting {name}": "ابدأ تعدّ {name}",
  "{count} in stock now.": "{count} في المخزون دلوقتي.",
  "Enter how many you have. From then on, each order takes from this number and the item hides itself when it runs out.": "اكتب عندك كام. بعد كده كل طلب هيسحب من الرقم ده والصنف هيستخبى لوحده لما يخلص.",
  "What happened?": "إيه اللي حصل؟",
  "How many are there now?": "فيه كام دلوقتي؟",
  "How many arrived?": "وصل كام؟",
  "How many to remove?": "هتشيل كام؟",
  "You only have {count}.": "عندك {count} بس.",
  "New stock: {count}": "المخزون الجديد: {count}",
  "Warn me when it gets down to (optional)": "نبّهني لما يوصل لـ (اختياري)",
  "e.g. 5": "مثلًا 5",
  "Note (optional)": "ملاحظة (اختياري)",
  "Supplier, invoice number, reason…": "المورّد، رقم الفاتورة، السبب…",
  "Save stock": "احفظ المخزون",
  "Saving…": "بيتحفظ…",
  "Cancel": "إلغاء",

  // Stock history
  "Could not load stock history.": "مقدرناش نحمّل سجل المخزون.",
  "Delivery": "استلام",
  "Counted": "جرد",
  "Removed": "اتشال",
  "Ordered": "اتطلب",
  "Order cancelled": "طلب اتلغى",
  "Every change to counted items, newest first.": "كل تغيير في الأصناف المتعدّة، الأحدث الأول.",
  "No stock changes yet.": "لسه مفيش تغييرات في المخزون.",
  "When": "امتى",
  "Item": "الصنف",
  "What": "إيه",
  "Change": "التغيير",
  "Left": "الباقي",

  // Menu item dialog
  "Give the item a name.": "اكتب اسم للصنف.",
  "Price must be a valid non-negative number.": "السعر لازم يكون رقم صحيح مش سالب.",
  "Stock numbers must be 0 or more.": "أرقام المخزون لازم تكون 0 أو أكتر.",
  "Stock-tracked items need a connection to save.": "الأصناف اللي بتتعدّ محتاجة نت عشان تتحفظ.",
  "Could not save food item.": "مقدرناش نحفظ الصنف.",
  "Add a menu item": "ضيف صنف للمنيو",
  "Guests see the name, price, photo and description in the app.": "الضيوف بيشوفوا الاسم والسعر والصورة والوصف في التطبيق.",
  "Name": "الاسم",
  "Price (EGP)": "السعر (جنيه)",
  "Description (optional)": "الوصف (اختياري)",
  "Photo (optional)": "صورة (اختياري)",
  "Upload photo": "ارفع صورة",
  "Uploading image…": "بنرفع الصورة…",
  "Image upload is unavailable while offline.": "رفع الصور مش متاح من غير نت.",
  "Turn off to hide it without deleting it.": "اقفله عشان تخبيه من غير ما تمسحه.",
  "Count stock for this item": "اعدّ مخزون الصنف ده",
  "Good for cans, bottles and packaged snacks. Orders take from the count and the item hides itself at 0.": "مناسب للكانز والإزايز والسناكس المتغلّفة. الطلبات بتسحب من العدد والصنف بيستخبى لوحده لما يوصل 0.",
  "How many do you have now?": "عندك كام دلوقتي؟",
  "{count} in stock. Use Update stock to change it.": "{count} في المخزون. استخدم تحديث المخزون عشان تغيّره.",
  "Warn me at (optional)": "نبّهني عند (اختياري)",
  "Save changes": "احفظ التعديلات",
  "Delete": "مسح",
  "beverages": "مشروبات",
  "drinks": "مشروبات",
  "snacks": "سناكس",
  "meals": "وجبات",
  "desserts": "حلويات",
  "other": "أخرى",

  // Home
  "Playing now": "بيلعبوا دلوقتي",
  "{live} of {total}": "{live} من {total}",
  "Free to play": "فاضي للعب",
  "Orders waiting": "طلبات مستنية",
  "Oldest: {count} min": "الأقدم: {count} دقيقة",
  "Open or close the day": "افتح أو اقفل اليوم",
  "Sold out and hidden from guests: {items}": "خلص ومستخبي عن الضيوف: {items}",
  "Restock": "زوّد المخزون",
  "New booking": "حجز جديد",
  "Start walk-in": "ابدأ جلسة بدون حجز",

  // Navigation
  "{count} playing now": "{count} بيلعبوا دلوقتي",
  "{count} open orders": "{count} طلبات مفتوحة",
  "{count} pending": "{count} مستني",
  "{count} unread": "{count} مش مقروء",
  "Notifications": "الإشعارات",
  "Workspace role": "الدور في مساحة العمل",

  // Venue setup
  "The food and drink menu now lives in Menu & stock, together with stock counts.": "منيو الأكل والمشروبات بقى في «المنيو والمخزون» مع عدّ المخزون.",
  "Open Menu & stock": "افتح المنيو والمخزون",
  "You have unsaved changes. Closing will discard them.": "عندك تعديلات مش محفوظة. لو قفلت هتضيع.",

  // Floor
  "New food order received — ready for triage.": "وصل طلب أكل جديد — جاهز للمتابعة.",
  "Needs attention": "محتاج انتباه",
  "{duration} · {amount}": "{duration} · {amount}",
  "End": "إنهاء",
  "End session": "إنهاء الجلسة",
  "Food triage queue": "طابور طلبات الأكل",
  "Orders stay here until they are picked up, even when the session is no longer on the live floor.": "الطلبات بتفضل هنا لحد ما تتسلّم، حتى لو الجلسة خلصت.",
  "Session {id}": "جلسة {id}",
  "{visible} of {total} units": "{visible} من {total} وحدة",
  "Clear filters": "امسح الفلاتر",
  "For the next walk-in:": "للجلسة الجاية بدون حجز:",
  "Guest name (optional)": "اسم الضيف (اختياري)",
  "Minutes": "الدقايق",
  "Phone, email, note": "تليفون، إيميل، ملاحظة",
  "Walk-in guest": "ضيف بدون حجز",

  // Checkout
  "Could not open the receipt print window. Allow popups and try again.": "مقدرناش نفتح نافذة طباعة الإيصال. اسمح بالنوافذ المنبثقة وجرّب تاني.",
  "Receipt printed, but the print count could not be updated.": "الإيصال اتطبع، بس مقدرناش نحدّث عدد مرات الطباعة.",
  "Enter a refund amount up to the paid total and a reason.": "اكتب مبلغ الاسترداد لحد المدفوع وسبب.",
  "Refund recorded for {number}.": "اتسجّل استرداد لـ {number}.",
  "Could not record refund.": "مقدرناش نسجّل الاسترداد.",
  "Receipts tabs": "تبويبات الإيصالات",
  "Queue": "المستني",
  "History": "السجل",
  "Sessions ready": "جلسات جاهزة للحساب",
  "Not billed yet": "لسه متحاسبش",
  "Balance due": "المتبقي",
  "Tap to bill": "دوس عشان تحاسب",
  "Select a session to see what is due.": "اختار جلسة عشان تشوف المطلوب.",
  "Issue without payment": "طلّع إيصال من غير دفع",
  "Paid in full": "اتدفع بالكامل",
  "No balance due": "مفيش مبلغ متبقي",
  "Details": "التفاصيل",
  "Refund receipt": "إيصال استرداد",
  "Payments recorded": "المدفوعات المسجّلة",
  "Issue a refund to return all or part of the paid amount.": "اعمل استرداد لكل أو جزء من المبلغ المدفوع.",
  "Refund": "استرداد",
  "Refund {number}": "استرداد {number}",
  "Amount": "المبلغ",
  "Customer request, overcharge...": "طلب العميل، حساب زيادة...",
  "Refunding...": "بنسترد...",
  "Record refund": "سجّل الاسترداد",
  // Shift (cash till) and venue status
  "The till matches.": "الدرج مظبوط.",
  "The till is short by {amount}.": "الدرج ناقص {amount}.",
  "The till is over by {amount}.": "الدرج زيادة {amount}.",
  "Enter the cash in the till. Enter 0 if it's empty.": "اكتب الفلوس اللي في الدرج. اكتب 0 لو فاضي.",
  "Could not start the shift. Check your connection and try again.": "مقدرناش نبدأ الوردية. اتأكد من الاتصال وجرّب تاني.",
  "Count the cash in the till and enter the total.": "عدّ الفلوس اللي في الدرج واكتب الإجمالي.",
  "Could not end the shift. Check your connection and try again.": "مقدرناش نقفل الوردية. اتأكد من الاتصال وجرّب تاني.",
  "Shift ended": "الوردية اتقفلت",
  "End shift": "اقفل الوردية",
  "Start shift": "ابدأ وردية",
  "Count the cash in the till. We'll check it against what should be there.": "عدّ الفلوس اللي في الدرج، وهنقارنها باللي المفروض يكون موجود.",
  "A shift keeps track of the cash in the till. It doesn't open or close the venue; that follows your opening hours.": "الوردية بتتابع الفلوس اللي في الدرج. مش بتفتح ولا بتقفل المكان؛ ده ماشي على مواعيد الشغل.",
  "Start a new shift when the next person takes over the till.": "ابدأ وردية جديدة لما حد تاني يستلم الدرج.",
  "Done": "تمام",
  "Started {time}": "بدأت {time}",
  "Cash you counted": "الفلوس اللي عدّيتها",
  "Cash in the till now": "الفلوس اللي في الدرج دلوقتي",
  "Same as last count ({amount})": "زي آخر عدّ ({amount})",
  "Why it's short or over, who counted…": "ليه ناقص أو زيادة، مين عدّ…",
  "Who is on the till…": "مين على الدرج…",
  "Shifts need a connection.": "الورديات محتاجة نت.",
  "Starting cash": "فلوس البداية",
  "+ Cash taken this shift": "+ الكاش اللي اتحصّل في الوردية",
  "Should be in the till": "المفروض في الدرج",
  "You counted": "إنت عدّيت",
  "Close early today?": "تقفل بدري النهارده؟",
  "Players won't be able to book until {time}. Bookings already made for later today stay booked; check Bookings if you need to call anyone.": "اللاعيبة مش هيقدروا يحجزوا لحد {time}. الحجوزات اللي اتعملت لبعدين النهارده هتفضل زي ما هي؛ بص على الحجوزات لو محتاج تكلّم حد.",
  "Close early": "اقفل بدري",
  "Stay open": "خليه مفتوح",
  "Could not close early. Try again.": "مقدرناش نقفل بدري. جرّب تاني.",
  "Could not reopen. Try again.": "مقدرناش نفتح تاني. جرّب تاني.",
  "For players": "للاعيبة",
  "Open for bookings": "مفتوح للحجز",
  "Closed for bookings": "مقفول للحجز",
  "You closed early today. It reopens by itself at the next opening time.": "قفلت بدري النهارده. هيفتح لوحده في ميعاد الفتح الجاي.",
  "A planned closure is on. Manage closures in Venue setup → Hours.": "فيه إغلاق متسجّل دلوقتي. تقدر تديره من إعداد المكان ← المواعيد.",
  "This follows your weekly opening hours. You don't need to open or close anything each day.": "ده ماشي على مواعيد الشغل الأسبوعية. مش محتاج تفتح أو تقفل حاجة كل يوم.",
  "Close early today": "اقفل بدري النهارده",
  "Reopen now": "افتح دلوقتي",
  "Opening hours": "مواعيد الشغل",
  "Cash till": "درج الكاش",
  "Shift open": "الوردية مفتوحة",
  "No shift open": "مفيش وردية مفتوحة",
  "Since {time} · {amount} should be in the till": "من {time} · المفروض {amount} في الدرج",
  "Last shift ended {time}": "آخر وردية اتقفلت {time}",
  "Start one when you begin taking cash.": "ابدأ وردية لما تبدأ تحصّل كاش.",
  "End the shift when you close up or hand the till to someone else. You'll count the cash and see if anything is missing.": "اقفل الوردية لما تقفل المكان أو تسلّم الدرج لحد تاني. هتعدّ الفلوس وتشوف لو فيه حاجة ناقصة.",
  "A shift tracks the cash in the till so you can spot missing money. It doesn't affect bookings.": "الوردية بتتابع الفلوس اللي في الدرج عشان تعرف لو فيه فلوس ناقصة. مالهاش علاقة بالحجوزات.",
  "No shift is open, so this cash won't be counted in a till check.": "مفيش وردية مفتوحة، فالكاش ده مش هيتحسب في جرد الدرج.",
  "Could not load the shift.": "مقدرناش نحمّل الوردية.",
  "Cash till (shift)": "درج الكاش (الوردية)",
  "No shift": "مفيش وردية",
  "Short / over": "ناقص / زيادة",
  "Shift not ended": "الوردية لسه مفتوحة",
  "Started": "بدأت",
  "Ended": "اتقفلت",
  "Closed until {time}": "مقفول لحد {time}",
  "for bookings, from your opening hours": "للحجز، حسب مواعيد الشغل",
  // Home
  "{names} +{count} more": "{names} و{count} كمان",
  "Players are waiting for a yes or no.": "اللاعيبة مستنيين رد بالموافقة أو الرفض.",
  "Oldest waiting {count} min": "الأقدم مستني {count} دقيقة",
  "Open orders": "افتح الطلبات",
  "Open floor": "افتح الصالة",
  "Sold out: {names}": "خلص: {names}",
  "Low: {names}": "قرب يخلص: {names}",
  "{live} of {total} playing": "{live} من {total} بيلعبوا",
  "Walk-in": "بدون حجز",
  "Food order": "طلب أكل",
  "Nothing needs you right now.": "مفيش حاجة محتاجاك دلوقتي.",
  "Coming up": "الجاي",
  "All bookings": "كل الحجوزات",
  "Today's money": "فلوس النهارده",
  "Hide details": "اخفي التفاصيل",
  "Billed": "المطلوب",
  "Paid": "المدفوع",
  "Unpaid": "مش مدفوع",
  "Review": "راجع",
  "{count} booking to confirm": "حجز واحد مستني التأكيد",
  "{count} bookings to confirm": "{count} حجوزات مستنية التأكيد",
  "{count} food order open": "طلب أكل واحد مفتوح",
  "{count} food orders open": "{count} طلبات أكل مفتوحة",
  "{count} session over time": "جلسة واحدة عدّت وقتها",
  "{count} sessions over time": "{count} جلسات عدّت وقتها",
  "{count} item needs restocking": "صنف واحد محتاج تزويد",
  "{count} items need restocking": "{count} أصناف محتاجة تزويد",
  "{count} unit free": "وحدة واحدة فاضية",
  "{count} units free": "{count} وحدات فاضية",
  "{amount} in the till · since {time}": "{amount} في الدرج · من {time}",
  "Tracks the cash in the till": "بتتابع الكاش اللي في الدرج",
  "Updating bookings…": "بنحدّث الحجوزات…",
  // Floor
  "Floor": "الصالة",
  "Ordered {time}": "اتطلب {time}",
  "{amount} an hour": "{amount} في الساعة",
  "Held for a booking.": "محجوز لحجز.",
  "Blocked. Change it in Venue setup → Units.": "موقوف. غيّره من إعداد المكان ← الوحدات.",
  "Offline. Change it in Venue setup → Units.": "مش شغّال. غيّره من إعداد المكان ← الوحدات.",
  "Time so far": "الوقت لحد دلوقتي",
  "Add time": "زوّد وقت",
  "Add {minutes} minutes": "زوّد {minutes} دقيقة",
  "{count} playing": "{count} بيلعبوا",
  "{count} free": "{count} فاضي",
  "{count} reserved": "{count} محجوز",
  "{count} over time": "{count} عدّى وقته",
  "No units yet. Add them in Venue setup → Units.": "مفيش وحدات لسه. ضيفها من إعداد المكان ← الوحدات.",
  "Ended recently": "خلصت من شوية",
  "Sessions that just finished. Take payment for any that aren't paid yet.": "جلسات لسه خالصة. حصّل حساب أي جلسة لسه مدفعتش.",
  "Not paid yet": "لسه مدفعش",
  "{count} not paid yet": "{count} لسه مدفعوش",
  "Take payment": "حصّل الحساب",
  "Receipt": "الإيصال",
  "Food & drinks": "الأكل والمشروبات",
  "Food": "أكل",
  "{count} seat": "{count} كرسي",
  "Time left": "الوقت الباقي",
  "Over time by": "عدّى الوقت بـ",
  "Playing for": "بيلعب من",
  "Booking": "حجز",
  "Start walk-in: {unit}": "جلسة بدون حجز: {unit}",
  "For guests without a booking. The timer starts now.": "للضيوف اللي من غير حجز. العدّاد هيبدأ دلوقتي.",
  "How long?": "المدة كام؟",
  "Other length in minutes": "مدة تانية بالدقايق",
  "Other (min)": "غير كده (دقيقة)",
  "Choose between 15 minutes and 12 hours.": "اختار ما بين 15 دقيقة و12 ساعة.",
  "About {amount} for {duration}": "حوالي {amount} لمدة {duration}",
  "You can add time or end early. The bill uses the actual time played.": "تقدر تزوّد وقت أو تنهي بدري. الحساب على الوقت الفعلي.",
  "Hide phone, email, note": "اخفي التليفون والإيميل والملاحظة",
  "Add phone, email or note": "ضيف تليفون أو إيميل أو ملاحظة",
  "Start timer": "ابدأ العدّاد",
  "Phone": "التليفون",
  "Email": "الإيميل",
  "Note": "ملاحظة",

  // Notifications
  "New booking request": "طلب حجز جديد",
  "Booking confirmed": "الحجز اتأكد",
  "Booking declined": "الحجز اترفض",
  "Booking cancelled": "الحجز اتلغى",
  "Booking request expired": "طلب الحجز انتهى",
  "Session extended": "الجلسة اتمدّت",
  "Order being prepared": "الطلب بيتحضّر",
  "Order ready to serve": "الطلب جاهز للتقديم",
  "Order served": "الطلب اتقدّم",
  "Food order cancelled": "طلب الأكل اتلغى",
  "Your account was approved": "حسابك اتوافق عليه",
  "Your registration was declined": "تسجيلك اترفض",
  "Your account was suspended": "حسابك اتوقف",
  "Venue declined": "المكان اترفض",
  "Venue removed": "المكان اتشال",
  "Venue removal declined": "طلب شيل المكان اترفض",
  "Password changed": "كلمة السر اتغيرت",
  "Email changed": "الإيميل اتغير",
  "from the app": "من التطبيق",
  "by {name}": "بواسطة {name}",
  "Close notifications": "اقفل الإشعارات",

  // Bookings
  "Tomorrow": "بكرة",
  "Decline {name}'s booking?": "ترفض حجز {name}؟",
  "{unit}, {when}. The player is told it was declined and the time becomes free again.": "{unit}، {when}. هنبلّغ اللاعب إن الحجز اترفض والوقت يفضى تاني.",
  "Decline": "رفض",
  "Keep request": "سيب الطلب",
  "Decline {name}'s booking": "رفض حجز {name}",
  "Loading bookings…": "بنحمّل الحجوزات…",
  "Players are waiting. Confirm to hold the time for them, or decline to free it.": "اللاعيبة مستنيين. أكّد عشان تحجز لهم الوقت، أو ارفض عشان يفضى.",
  "No bookings in the next 30 days.": "مفيش حجوزات في الـ30 يوم الجايين.",
  "{count} request to confirm": "طلب واحد مستني التأكيد",
  "{count} requests to confirm": "{count} طلبات مستنية التأكيد",
  "{count} booking": "حجز واحد",
  "Upcoming": "الجاية",
  "Past": "اللي فاتت",
  "The next 30 days.": "الـ30 يوم الجايين.",
  "The last 30 days.": "آخر 30 يوم.",
  "Previous": "السابق",
  "{count} request waiting for you.": "طلب واحد مستنيك.",
  "{count} requests waiting for you.": "{count} طلبات مستنياك.",
  "{count} booking shown.": "حجز واحد ظاهر.",
  "{count} bookings shown.": "{count} حجوزات ظاهرة.",
  "Could not print the receipt. Allow popups and try again.": "مقدرناش نطبع الإيصال. اسمح بالنوافذ المنبثقة وجرّب تاني.",
  "Could not prepare the receipt for printing.": "مقدرناش نجهّز الإيصال للطباعة.",
  "The player is waiting for you to confirm or decline this request.": "اللاعب مستني تأكيدك أو رفضك للطلب ده.",
  "Time so far {value}": "الوقت لحد دلوقتي {value}",
  "Optional: why, for the record (e.g. guest called to cancel)": "اختياري: السبب، للتسجيل (مثلًا الضيف اتصل يلغي)",
  "Booking total": "إجمالي الحجز",
  "First visit: no earlier bookings or sessions with you.": "أول زيارة: مفيش حجوزات أو جلسات قبل كده.",
  "Copied": "اتنسخ",
  "Copy code": "انسخ الكود",
  "Account details": "تفاصيل الحساب",
  "Choose the day and start time.": "اختار اليوم وميعاد البداية.",
  "The booking must be at least 15 minutes.": "الحجز لازم يكون 15 دقيقة على الأقل.",
  "{duration}, about {amount}": "{duration}، حوالي {amount}",
  "Until {time}": "لحد {time}",
  "Guest name": "اسم الضيف",
  "Who is the booking for?": "الحجز باسم مين؟",
  "Email (optional)": "الإيميل (اختياري)",
  "Birthday, extra controllers…": "عيد ميلاد، دراعات زيادة…",
  "Cancel booking": "إلغاء الحجز",
  "Didn't show up": "مجاش",

  // Checkout
  "{count} bill waiting to be paid.": "حساب واحد مستني الدفع.",
  "{count} bills waiting to be paid.": "{count} حسابات مستنية الدفع.",
  "Nothing waiting to be paid.": "مفيش حاجة مستنية الدفع.",
  "Every receipt issued at {venue}.": "كل الإيصالات اللي طلعت في {venue}.",
  "To pay": "للدفع",
  "Waiting to pay": "مستني الدفع",
  "Part paid": "مدفوع جزء",
  "Receipt {number}": "إيصال {number}",
  "This table is still playing. The bill grows until you end the session on the Floor; you can take a payment now if the guest wants to pay early.": "الطاولة لسه بتلعب. الحساب بيزيد لحد ما تنهي الجلسة من الصالة؛ تقدر تحصّل دلوقتي لو الضيف عايز يدفع بدري.",
  "Cash received": "الكاش المستلم",
  "Quick amounts": "مبالغ سريعة",
  "Exact": "المبلغ بالظبط",
  "Give back {amount} change": "رجّع {amount} باقي",
  "Take {amount} by {method}": "حصّل {amount} {method}",
  "Receipt details": "تفاصيل الإيصال",
  "Only for receipts issued by mistake, before any payment.": "للإيصالات اللي طلعت بالغلط بس، قبل أي دفع.",

  // Counter sales
  "Counter": "الكاونتر",
  "Pay now, no table": "ادفع دلوقتي، من غير طاولة",
  "Counter sale": "بيع على الكاونتر",
  "Choose how they're paying.": "اختار طريقة الدفع.",
  "The cash received is less than the total.": "الكاش المستلم أقل من الإجمالي.",
  "Name for the order (optional)": "اسم على الطلب (اختياري)",
  "So the kitchen can call it out": "عشان المطبخ ينادي عليه",
  "Take {amount} and send": "حصّل {amount} وابعت",
  "Paid and sent to the queue. Receipt {number}.": "اتدفع واتبعت للطابور. إيصال {number}.",
  "Pick a table or the counter, tap what they want, then send it to the queue.": "اختار طاولة أو الكاونتر، دوس على اللي عايزينه، وابعته للطابور.",

  // Alerts
  "Sound off": "الصوت مقفول",
  "Plays a chime for new orders and bookings. Tap to switch.": "بيعمل صوت تنبيه للطلبات والحجوزات الجديدة. دوس للتغيير.",
  "Sound on": "الصوت شغّال",
  "Sound on for new orders": "الصوت شغّال للطلبات الجديدة",
  "Sound off for new orders": "الصوت مقفول للطلبات الجديدة",

  // Venue setup, Customers, Business
  "{used} of {limit} photos. The main photo is shown first in the app. You can also drop images here.": "{used} من {limit} صور. الصورة الرئيسية بتظهر الأول في التطبيق. ممكن كمان تسحب الصور هنا.",
  "Main photo": "الصورة الرئيسية",
  "Make main photo": "خليها الصورة الرئيسية",
  "Setup": "الإعداد",
  "Venue setup": "إعداد المكان",
  "What players see in the app: photos, units and prices, opening hours and games.": "اللي اللاعبين بيشوفوه في التطبيق: الصور، الأجهزة والأسعار، مواعيد الفتح والألعاب.",
  "Add a venue": "إضافة مكان",
  "Your venues": "أماكنك",
  "Finish these so players see a complete venue.": "كمّل دول عشان اللاعبين يشوفوا المكان كامل.",
  "Edit details": "تعديل التفاصيل",
  "Open in Maps": "افتح في الخرائط",
  "Not set. Players can't get directions.": "مش متحدد. اللاعبين مش هيعرفوا يوصلوا.",
  "Time zone": "المنطقة الزمنية",
  "Regulars and guests": "الزباين الدايمين والضيوف",
  "Everyone who has booked or played here.": "كل اللي حجز أو لعب هنا.",
  "{count} person has booked or played here.": "{count} شخص حجز أو لعب هنا.",
  "{count} people have booked or played here.": "{count} شخص حجزوا أو لعبوا هنا.",
  "Yesterday": "امبارح",
  "Business & team": "النشاط والفريق",
  "How you take payment and print receipts, your business details, and who can use this workspace.": "إزاي بتاخد الفلوس وبتطبع الإيصالات، بيانات نشاطك، ومين يقدر يستخدم مساحة العمل دي.",
  "Save business details": "حفظ بيانات النشاط",
  "Save payments & receipts": "حفظ الدفع والإيصالات",
  "Payments & receipts": "الدفع والإيصالات",
  "At checkout": "عند الدفع",
  "Add VAT": "إضافة ضريبة القيمة المضافة",
  "Add a service fee": "إضافة رسوم خدمة",
  "Loading settings...": "بنحمّل الإعدادات...",
};
